import { render, staticRenderFns } from "./Restricoes.vue?vue&type=template&id=d682ddaa&"
import script from "./Restricoes.vue?vue&type=script&lang=js&"
export * from "./Restricoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports